import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { useAtom, useAtomValue, WritableAtom } from 'jotai';
import { errorAtom } from 'atoms/error';
import { authTokenAtom } from 'atoms/authAtoms';
import { useDestinations } from 'utils/hooks/useLToolTree';
import { useAutoSelectSingle } from 'utils/hooks/useAutoSelectSingle';
import { Config } from 'atoms/Ltool/newConfigAtoms';

type Props = {
    atom: WritableAtom<string, [newProjectId: string], void>;
    config: Config;
};

export const DestinationSelect: React.FC<Props> = ({ atom, config }) => {
    const authToken = useAtomValue(authTokenAtom);
    const [destinationId, setDestinationId] = useAtom(atom);
    const [error] = useAtom(errorAtom);
    const { items: destinations, loading } = useDestinations(authToken, config);
    // 選択肢が1件のみの段は自動選択し、一意に定まる限り下位へ連鎖させる
    useAutoSelectSingle(destinations, loading, destinationId, setDestinationId);

    return (
        <Box sx={{ flex: '1 1 calc(50% - 16px)' }}>
            <FormControl fullWidth disabled={!config.project_id || loading} error={Boolean(error)}>
                <InputLabel id="destination-select-label">Destination</InputLabel>
                <Select
                    labelId="destination-select-label"
                    value={destinationId}
                    label="Destination"
                    onChange={(e) => setDestinationId(e.target.value as string)}
                >
                    <MenuItem value="">
                        <em>None</em>
                    </MenuItem>
                    {destinations.map((dest) => (
                        <MenuItem key={dest} value={dest}>
                            {dest}
                        </MenuItem>
                    ))}
                </Select>
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{ position: 'absolute', top: '50%', right: 16, mt: '-12px' }}
                    />
                )}
            </FormControl>
        </Box>
    );
};
